<template>
	<section
		v-editable="blok"
		class="container"
	>
		<StoryblokComponent
			v-for="item in blok.presentionalTiles"
			:key="item._uid"
			:blok="item"
		/>
	</section>
</template>

<script setup lang="ts">
	import type {SummerLotteryEndedVariantStoryblok} from '@/storyblok/types';

	interface Props {
		blok: SummerLotteryEndedVariantStoryblok
	}

	defineProps<Props>();
</script>
